// 按文件扩展名推断 MIME 类型。用于「按 NAS 上实测落盘文件登记元数据」的场景
// （如 DaVinci 渲染产物：扩展名由 preset 决定，服务端 ls 后据此回填 biz_file.mimeType）。
// 只覆盖本系统会遇到的媒体类扩展名；未知扩展名回落 application/octet-stream。
// 纯字符串实现（不依赖 node:path），浏览器与 node 两侧均可安全使用。

const MIME_BY_EXTENSION: Record<string, string> = {
  // 视频
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  m4v: 'video/x-m4v',
  mxf: 'application/mxf',
  webm: 'video/webm',
  mkv: 'video/x-matroska',
  avi: 'video/x-msvideo',
  // 音频
  wav: 'audio/wav',
  aif: 'audio/aiff',
  aiff: 'audio/aiff',
  mp3: 'audio/mpeg',
  aac: 'audio/aac',
  flac: 'audio/flac',
  // 图像
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  tif: 'image/tiff',
  tiff: 'image/tiff',
}

const DEFAULT_MIME_TYPE = 'application/octet-stream'

// 取文件名最后一个 '.' 之后的小写扩展名查表；无扩展名 / 未知扩展名 → application/octet-stream。
export const mimeTypeByExtension = (filename: string): string => {
  const dot = filename.lastIndexOf('.')
  if (dot < 0 || dot === filename.length - 1) return DEFAULT_MIME_TYPE
  const ext = filename
    .slice(dot + 1)
    .toLowerCase()
  return MIME_BY_EXTENSION[ext] ?? DEFAULT_MIME_TYPE
}
